function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, mergeProps as _mergeProps, createBlock as _createBlock } from "vue";
import { ElDialog } from 'element-plus';
import 'element-plus/es/components/dialog/style/css'

import { onMounted, watch, useAttrs } from 'vue';
import { sleep } from '@/js/lib/helper/sleep';
import IButton from './IButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'IModal',
    props: /*@__PURE__*/ _mergeModels({
        width: {
            default: '500px'
        },
        textCancel: {
            default: 'キャンセル'
        },
        textOk: {
            default: 'OK'
        },
        withCloseButton: {
            type: Boolean,
            default: true
        },
        withActionButton: {
            type: Boolean
        },
        withCancelButton: {
            type: Boolean,
            default: true
        },
        closeOnCancel: {
            type: Boolean,
            default: true
        },
        closeOnOk: {
            type: Boolean,
            default: true
        },
        fadeOut: {
            type: Boolean
        },
        isLoading: {
            type: Boolean
        }
    }, {
        "modelValue": _object_spread({
            type: Boolean
        }, {
            default: true
        }),
        "modelModifiers": {}
    }),
    emits: /*@__PURE__*/ _mergeModels([
        "open",
        "close",
        "cancel",
        "ok"
    ], [
        "update:modelValue"
    ]),
    setup (__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const attrs = useAttrs();
        const isShow = _useModel(__props, "modelValue");
        const modalClose = ()=>{
            isShow.value = false;
        };
        const onCancel = ()=>{
            if (props.closeOnCancel) {
                isShow.value = false;
            }
            emit('cancel');
        };
        const onOk = ()=>{
            emit('ok');
            if (props.closeOnOk) {
                isShow.value = false;
            }
        };
        onMounted(()=>_async_to_generator(function*() {
                if (props.fadeOut) {
                    yield sleep(1200);
                    isShow.value = false;
                }
            })());
        watch(isShow, (newValue)=>{
            if (newValue) {
                emit('open');
            } else {
                emit('close');
            }
        });
        __expose({
            modalClose
        });
        return (_ctx, _cache)=>{
            return _openBlock(), _createBlock(_unref(ElDialog), _mergeProps({
                modelValue: isShow.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>isShow.value = $event),
                class: [
                    _ctx.$style.dialog,
                    __props.isLoading && _ctx.$style.loading
                ],
                width: __props.width,
                "append-to-body": true,
                "show-close": __props.withCloseButton
            }, _unref(attrs)), {
                default: _withCtx(()=>[
                        _createElementVNode("div", {
                            class: _normalizeClass([
                                __props.withActionButton && _ctx.$style.withActionButton
                            ])
                        }, [
                            _createElementVNode("div", {
                                class: _normalizeClass(_ctx.$style.content)
                            }, [
                                _renderSlot(_ctx.$slots, "default")
                            ], 2),
                            _cache[2] || (_cache[2] = _createTextVNode()),
                            __props.withActionButton ? (_openBlock(), _createElementBlock(_Fragment, {
                                key: 0
                            }, [
                                __props.withCancelButton ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass([
                                        _ctx.$style.buttonArea,
                                        _ctx.$style.hasCancel
                                    ])
                                }, [
                                    _createVNode(IButton, {
                                        onClick: onCancel
                                    }, {
                                        default: _withCtx(()=>[
                                                _createTextVNode(_toDisplayString(__props.textCancel), 1)
                                            ]),
                                        _: 1
                                    }),
                                    _cache[1] || (_cache[1] = _createTextVNode()),
                                    _createVNode(IButton, {
                                        type: "primary",
                                        onClick: onOk
                                    }, {
                                        default: _withCtx(()=>[
                                                _createTextVNode(_toDisplayString(__props.textOk), 1)
                                            ]),
                                        _: 1
                                    })
                                ], 2)) : (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(_ctx.$style.buttonArea)
                                }, [
                                    _createVNode(IButton, {
                                        type: "primary",
                                        onClick: onOk
                                    }, {
                                        default: _withCtx(()=>[
                                                _createTextVNode(_toDisplayString(__props.textOk), 1)
                                            ]),
                                        _: 1
                                    })
                                ], 2))
                            ], 64)) : _createCommentVNode("", true),
                            _cache[3] || (_cache[3] = _createTextVNode()),
                            _ctx.$slots.footer ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(_ctx.$style.footer)
                            }, [
                                _renderSlot(_ctx.$slots, "footer")
                            ], 2)) : _createCommentVNode("", true)
                        ], 2)
                    ]),
                _: 3
            }, 16, [
                "modelValue",
                "class",
                "width",
                "show-close"
            ]);
        };
    }
});
